var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 11,
    viewBox: "0 0 20 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.982 0.0200027C18.8511 0.018407 18.7214 0.0442207 18.6011 0.0957846C18.4807 0.147348 18.3725 0.223521 18.2834 0.319404L10 8.58288L1.71657 0.319404C1.31736 -0.0797976 0.698603 -0.0797976 0.299401 0.319404C-0.0998004 0.718606 -0.0998004 1.33737 0.299401 1.73657L9.3014 10.6986C9.7006 11.0978 10.3194 11.0978 10.7186 10.6986L19.7006 1.71661C20.0998 1.31741 20.0998 0.698645 19.7006 0.299444C19.501 0.0998427 19.2415 4.21259e-05 19.002 4.21259e-05L18.982 0.0200027Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/Down.bcdd3e813096d182e5e1ad2022a24378.svg";
export { ForwardRef as ReactComponent };